<template>
    <el-dialog title="New Customer"
               width="50%"
               :visible="showForm"
               :show-close="!isBusy"
               @close="$emit('is-visible', false)"
               :close-on-click-modal="!isBusy"
               :close-on-press-escape="!isBusy">
        <el-alert v-if="formErrors.length > 0" type="error" title="Form contains errors:" :closable="false">
            <ul>
                <li v-for="(error, index) of formErrors" :key="`error_li_${index}`">{{ error }}</li>
            </ul>
        </el-alert>
        <el-form :model="customer" ref="customerForm" :rules="formRules">
            <el-form-item label="Company" prop="company" class="mb-10" required>
                <el-input type="text" v-model="customer.company"/>
            </el-form-item>
            <el-row>
                <el-col :span="12" class="pr-5">
                    <el-form-item label="Email" prop="email" class="mb-10" required>
                        <el-input type="text" v-model="customer.email"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="pr-5">
                    <el-form-item label="Phone" prop="phone" class="mb-10">
                        <el-input type="text" v-model="customer.phone"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="Description" prop="description" class="mb-5">
                <el-input type="text" v-model="customer.description"/>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                    <el-button @click="$emit('is-visible', false)" :disabled="isBusy">Cancel</el-button>
                    <el-button type="primary" @click="validateCustomer" :loading="isBusy">Create</el-button>
                </span>
    </el-dialog>
</template>

<script>
const stringMaxLength = 255;
const incorrectLengthMsg = 'Length should be below ' + stringMaxLength + ' characters';

export default {
    props: {
        showForm: { type: Boolean, required: true },
        employerId: { type: Number, required: true },
        employerName: { type: String, required: true },
        employerEmail: { type: String, required: true },
        employerPhone: { type: String, required: true },
    },
    data() {
        return {
            isBusy: false,
            customer: {},
            formErrors: [],
            formRules: {
                company: [
                    { required: true, message: 'Please input Company Name.', trigger: 'blur' },
                    { max: stringMaxLength, message: incorrectLengthMsg, trigger: 'blur' },
                ],
                email: [
                    { required: true, message: 'Please input Company e-mail address.', trigger: 'blur' },
                    { max: stringMaxLength, message: incorrectLengthMsg, trigger: 'blur' },
                ],
                phone: [{ max: stringMaxLength, message: incorrectLengthMsg, trigger: 'blur' }],
                description: [{ max: stringMaxLength, message: incorrectLengthMsg, trigger: 'blur' }],
            },
        };
    },
    computed: {
        emptyCustomer: function () {
            return {
                company: this.employerName,
                email: this.employerEmail,
                phone: this.employerPhone,
                description: '',
            };
        },
    },
    mounted() {
        this.customer = this.emptyCustomer;
    },
    methods: {
        validateCustomer() {
            this.$refs['customerForm'].validate((valid) => {
                if (valid) {
                    this.createCustomer();
                } else {
                    return false;
                }
            });
        },
        createCustomer() {
            const $this = this;
            $this.isBusy = true;

            axios.post(url(`admin/employer/${$this.employerId}/paygate/create-customer`), $this.customer)
                 .then(response => {
                     const data = response.data;
                     if (typeof data.id !== 'undefined' && typeof data.token !== 'undefined') {
                         $this.$emit('created', {
                             customerId: data.id,
                             customerToken: data.token,
                             customerCompany: $this.customer.company,
                             customerEmail: $this.customer.email
                         });
                         $this.customer = $this.emptyCustomer;
                         $this.$emit('is-visible', false);
                     } else if (typeof data.error !== 'undefined' && data.error === true) {
                         $this.formErrors = data.messages;
                     } else {
                         throw Error('Whoops, looks like something went wrong.');
                     }
                 })
                 .catch(err => this.$message.error(err.message))
                 .finally(() => {
                     $this.isBusy = false;
                 });
        },
    },
};
</script>

<style scoped>
.pr-5 { padding-right: 5px; }

.mb-5 { margin-bottom: 5px; }

.mb-10 { margin-bottom: 10px; }
</style>